module.exports = __webpack_public_path__ + "img/p1-p2-juanzhou.54d06175.png";